<template>
  <div>
    <div class="page-article">
      <div class="waterfall-win list">
        <div
          class="card-item"
          v-for="(item, index) in articleList"
          :key="index"
          @click="goDetail(item)"
        >
          <div class="pic">
            <img :src="cloudPic(item.articlePic, 'other')" />
          </div>
          <div class="card-info">
            <div class="title">{{ item.articleTitle }}</div>
            <div class="article-desc">
              <div
                class="desc-text"
                v-html="delHtmlTag(item.articleContent)"
              ></div>
              <span class="more-btn">详情</span>
            </div>
            <div class="footer">
              <div class="author">{{ item.articleAuthor }}</div>
              <div class="view">
                <!-- <span class="more-btn">详情</span> -->
                <i class="el-icon-view"></i>{{ item.pageview }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="float-black">
        <floatWin />
      </div>
    </div>
    <div
      v-if="hasMore && articleList.length > 0"
      class="loading-text"
      @click="fetchData"
    >
      加载更多
    </div>
    <div v-if="!hasMore" class="loading-ending">已经加载到底了~</div>
  </div>
</template>

<script>
import floatWin from "./floatWin.vue";
export default {
  name: "pageArticle",
  props: {
    keyword: {
      type: String,
      default: "",
    },
  },
  components: {
    floatWin,
  },
  watch: {
    $route(to, from) {
      if (this.$route.path === "/pageArticle" && from.name != "articleDetail") {
        this.init();
      }
    },
  },
  data() {
    return {
      articleList: [],
      page: 1, // 当前页数
      pageSize: 8, // 每页数据量
      hasMore: true, // 是否还有更多数据
      total: undefined,
      qr_img: "",
    };
  },
  methods: {
    ObserveDataTotal(length) {
      console.log(length);
    },
    //正则去掉所有的html标记
    delHtmlTag(str) {
      let string = str
        .replace(/<[^>]+>/g, "")
        .replace(/&nbsp;/g, "")
        .trim();
      let result;
      if (string.length > 60) {
        result = string.slice(0, 60) + "...";
      } else {
        result = string.slice(0, 60);
      }
      return result;
    },
    fetchData() {
      let obj = {
        pageIndex: this.page,
        pageSize: this.pageSize,
        articleStatus: 2,
      };
      this.api("getArticleList", obj).then((res) => {
        this.articleList = this.articleList.concat(res.result);
        this.total = res.total;
        this.page++;
        // 模拟数据全部加载完毕
        if (this.articleList.length >= this.total) {
          this.hasMore = false;
        }
      });
    },
    goDetail(item) {
      localStorage.setItem("articleContent", JSON.stringify({}));
      this.jump(`/articleDetail/${item.articleId}`);
      localStorage.setItem("articleContent", JSON.stringify(item));
    },
    linkHandle(val) {
      window.open(val.string2);
    },
    showMoreCourse(val) {
      this.qr_img = val.string2;
    },
    handleClose() {},
    init() {
      this.articleList = [];
      this.page = 1; // 当前页数
      this.total = undefined;
      this.hasMore = true;
      this.fetchData();
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss">
.pagename-pageArticle {
  background: #f5f5f5;
}
.dark {
  .pagename-pageArticle {
    background: #1a1a1a;
    color: #333;
  }
  .footer-container .el-footer {
    background: #151515;
    color: #555;
  }
  .loading-ending,
  .loading-text{
    color: #999;
  }
}
.page-article {
  padding: 30px 0;
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;

  .list {
    // overflow: hidden;
  }

  .card-item {
    width: 285px;
    margin-bottom: 25px;
    margin-right: 20px;
    border-radius: 5px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.005);
    float: left;
    cursor: pointer;
    &:nth-child(4n) {
      margin-right: 0;
    }
    .pic {
      width: 100%;
      height: 285px;
      overflow: hidden;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .card-info {
      padding: 10px 10px 20px 10px;
      .title {
        font-weight: bold;
        padding-bottom: 10px;
      }
      .article-desc {
        font-size: 13px;
        opacity: 0.7;
        padding-bottom: 15px;
        position: relative;
        .desc-text {
          // 三行省略
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .more-btn {
        color: #007fff;
        // position: absolute;
        // bottom: 15px;
        // right: 0;
        font-size: 12px;
        &:hover {
          color: #005599;
        }
      }
      .footer {
        display: flex;
        justify-content: space-between;
        font-size: 13px;
        color: #666;
      }
      .view {
        i {
          color: #f00;
        }
      }
    }
  }
  .float-black {
    float: right;
    margin-right: -166px;
  }
}
.loading-text {
  cursor: pointer;
}
.loading-text,
.loading-ending {
  text-align: center;
  font-size: 13px;
}
</style>
